import { IconProps } from "@design-system/types";

export function ColoredXIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="28"
      height="29"
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="2.33887"
        y="0.983398"
        width="36.2907"
        height="2.06197"
        rx="1.03099"
        transform="rotate(45 2.33887 0.983398)"
        fill="#0028ED"
      />
      <rect
        x="0.880798"
        y="26.5518"
        width="36.2907"
        height="2.06197"
        rx="1.03099"
        transform="rotate(-45 0.880798 26.5518)"
        fill="#0028ED"
      />
    </svg>
  );
}
